import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class ImpersonateService {
  constructor(private cookieService: CookieService) {}

  clearUserData(): void {
    this.cookieService.delete('token', '/');
    this.cookieService.delete('user_id', '/');
  }
}
